import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Next } from '../ControlButtons';
import BrandList from '../selects/BrandList';
import {
  howItWorks,
  howItWorksUS,
  howItWorksMobile,
  howItWorksMobileUS,
} from '../../images/icons';
import {
  dataLayerGA4HyperlinksInText,
  dataLayerGA4SizeQuizStageNumber,
} from '../../../shared/utils/data-layer';

const Stage1 = ({
  buttonSelected,
  defaultNextProps,
  intl: { formatMessage, locale },
  messages,
  setBackChange,
  setCupChange,
  setSelected,
  updateBrandSizes,
}) => {
  const STAGE_NUMBER = '1';

  useEffect(() => {
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <div className="stage stage-1">
      <div className="wrap">
        <div className="header-container">
          <h2 className="header u-text-size-2">
            {formatMessage(messages.stage1h2)}
          </h2>
          <p className="sub-header">
            {formatMessage(messages.stage1para1)}{' '}
            <a
              onClick={() => dataLayerGA4HyperlinksInText(STAGE_NUMBER)}
              href={`tel:${formatMessage(messages.phone)}`}
            >
              {formatMessage(messages.phone)}
            </a>
            {formatMessage(messages.stage1para1or)}{' '}
            <a
              onClick={() => dataLayerGA4HyperlinksInText(STAGE_NUMBER)}
              href={locale === 'en-GB' ? '/live-chat' : '/us/live-chat'}
            >
              {formatMessage(messages.liveChat)}
            </a>
          </p>
        </div>
        <div className="header-container">
          <p className="sub-header">{formatMessage(messages.stage1para2)}</p>
        </div>
        <img
          className="header-image"
          src={locale === 'en-GB' ? howItWorks : howItWorksUS}
          alt="How it works"
        />
        <img
          className="header-image--mobile"
          src={locale === 'en-GB' ? howItWorksMobile : howItWorksMobileUS}
          alt="How it works"
        />
        <h2 className="fullWidth">{formatMessage(messages.stage1h5)}</h2>
        <BrandList
          setSelected={setSelected}
          updateBrandSizes={el =>
            updateBrandSizes(el, setBackChange, setCupChange)
          }
        />
        <Next
          hasChevron
          disabled={!buttonSelected}
          {...defaultNextProps(1, 'Select your size')}
        />
      </div>
    </div>
  );
};

export default injectIntl(Stage1);

Stage1.propTypes = {
  braIcon: PropTypes.string,
  buttonSelected: PropTypes.number,
  BrandList: PropTypes.func,
  defaultNextProps: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  setBackChange: PropTypes.func,
  setCupChange: PropTypes.func,
  setSelected: PropTypes.func,
  updateBrandSizes: PropTypes.func,
};
